import { strictObjectAccess } from '@ackee/redux-utils';

export const period = strictObjectAccess({
    MONTHLY: 1,
    QUARTALLY: 3,
    BI_ANNUALLY: 6,
    ANNUALLY: 12,
});
